// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".titleBarButtons__button___3mThU{margin:0 0 0 5px}.titleBarButtons__backButton___wozQr{position:absolute;margin:25px 15px}.titleBarButtons__right___3Lvz9{position:absolute;top:0;right:0;padding:15px;display:flex}.titleBarButtons__endChatQuestion___3cR3x{padding:10px;text-align:center}.titleBarButtons__modalButton___3CrWo{height:40px;margin-top:15px}.titleBarButtons__cancelButton___1PNiH{color:#717070}html[dir=\"rtl\"] .titleBarButtons__button___3mThU{margin:0 5px 0 0}html[dir=\"rtl\"] .titleBarButtons__backButton___wozQr{transform:rotate(180deg);margin:25px 15px}html[dir=\"rtl\"] .titleBarButtons__right___3Lvz9{left:0;right:initial}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"button": "titleBarButtons__button___3mThU",
	"backButton": "titleBarButtons__backButton___wozQr",
	"right": "titleBarButtons__right___3Lvz9",
	"endChatQuestion": "titleBarButtons__endChatQuestion___3cR3x",
	"modalButton": "titleBarButtons__modalButton___3CrWo",
	"cancelButton": "titleBarButtons__cancelButton___1PNiH"
};
module.exports = exports;
